import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy URL → current canonical page
export const Route = createFileRoute("/terms")({
  beforeLoad: () => {
    throw redirect({ to: "/terms-and-conditions", statusCode: 301 });
  },
});
